import type { ViewMode } from '../types/sacrifice'

export type { ViewMode }

const MODES: ViewMode[] = ['global', 'user', 'admin']

/**
 * Reads the view mode from a /sacrifice/:projectId/:mode pathname.
 *
 * Returns the matching ViewMode when the path is on a `/sacrifice` route
 * and the mode segment is a known value. Returns `'global'` when the path
 * is a valid `/sacrifice/:projectId` route with no mode segment. Returns
 * `null` when the path is not a `/sacrifice` route at all.
 */
export const viewModeFromPathname = (pathname: string): ViewMode | null => {
  const segments = pathname.split('/')
  if (segments[1] !== 'sacrifice' || !segments[2]) {
    return null
  }
  const mode = segments[3] as ViewMode
  if (mode && MODES.includes(mode)) {
    return mode
  }
  return 'global'
}

/**
 * Builds the route path for a project + view mode (the mode base path, e.g.
 * `/sacrifice/provex/user`). Does NOT include the `user/:address` sub-segment —
 * address-specific navigations are constructed inline at the call sites.
 */
export const buildViewModePath = (projectId: string, mode: ViewMode): string =>
  `/sacrifice/${projectId}/${mode}`
